import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import Services from '../../services';
import PaymentMode from '../../paymentMode';
import ManualJournal from '../../manualJournal';
import BankManagement from '../../bank';

const Handler = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="container">
            <div className="my-3">
                <h3>Handler</h3>
            </div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs 
                    value={value} 
                    onChange={handleChange}
                    aria-label="handler tabs"
                    sx={{
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 500,
                        },
                        '& .Mui-selected': {
                            color: '#1976d2 !important',
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#1976d2',
                        },
                    }}
                >
                    <Tab label="Services" />
                    <Tab label="Payment Modes" />
                    <Tab label="Journals" />
                    <Tab label="Banks" />
                </Tabs>
            </Box>

            <Box sx={{ mt: 2 }}>
                {value === 0 && (
                    <Services />
                )}
                {value === 1 && (
                    <PaymentMode />
                )}
                {value === 2 && (
                    <ManualJournal />
                )}
                {value === 3 && (
                    <BankManagement />
                )}
            </Box>
        </div>
    );
};

export default Handler; 